import React, { Fragment, useRef } from 'react';
import { translate } from '../Services/translation';

const NavigationItem = ({ links = [], contentLink = null, block = null, additionalHeaderLinks = [], overlayElement = null }) => {
    const menuRef = useRef(null);
    const toggleMenu = () => {
        menuRef.current.classList.toggle('navbar__menu--show');
        if (overlayElement){
            overlayElement.current.classList.toggle('overlay--show');
        }
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    return (
        <Fragment>
            {!contentLink ? (
                <div className="navbar__icon--menu-container">
                <a
                        className="navbar__icon--menu"
                    onClick={toggleMenu}
                ></a>
                    <span>{translate('navigation.ourproducts')}</span>
                </div>
            ) : (
                <Fragment>
                    <a
                        className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                        } ${additionClass || ''}`}
                        href={contentLink.url || '#'}
                            dangerouslySetInnerHTML={{ __html: contentLink.iconUrl ? ("<img width='40' height='40' alt='" + contentLink.name +"' class='navbar__item-icon' src='" + contentLink.iconUrl + "'/>" + contentLink.name) : contentLink.name }}
                    ></a>
                    {links.length > 0 && (
                        <i className="navbar__icon navbar__icon--open fal fa-arrow-right" 
                        onClick={toggleMenu}></i>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <ul className="navbar__menu" ref={menuRef}>
                    <div className="navbar__menu-wrapper custom-scroll-mobile custom-scroll-desktop">
                    <div className="navbar__menu-header">
                        {!contentLink ? (
                            <span
                                className="navbar__icon"
                                onClick={toggleMenu}
                            > 
                            <span className="navbar__menu-header--close-button-wrapper"><i className="fal fa-times"></i></span>
                                <span className="navbar__menu-header--title">{translate('navigation.closemenu')}</span>
                            </span>
                            
                        ) : (
                            <Fragment>
                                <span
                                    className="navbar__icon"
                                    onClick={toggleMenu}
                                > 
                                <span className="navbar__menu-header--close-button-wrapper"><i className="fal fa-times"></i></span>
                                    <span className="navbar__menu-header--title">{translate('navigation.closemenu')}</span>
                                </span>
                                <div className="navbar__menu-header--go-back-wrapper">
                                <i
                                        className="fal fa-arrow-left"
                                    onClick={toggleMenu}
                                ></i>
                                <span
                                    className="navbar__title"
                                    onClick={toggleMenu}
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                ></span>
                                </div>
                                
                            </Fragment>
                        )}
                    </div>
                    {links.length > 0 &&
                        links.map(
                            (link, i) =>
                                hasNameOrChildren(link) && (
                                    <li className="navbar__item" key={link.url + i}>
                                        <NavigationItem
                                            links={link.links}
                                            contentLink={link}
                                            block={block}
                                            additionalHeaderLinks={additionalHeaderLinks}
                                        />
                                    </li>
                                )
                        )}
                    {additionalHeaderLinks && additionalHeaderLinks.length > 0 &&
                        <>
                            <ul className="navbar__additional-header-links">
                                {additionalHeaderLinks.map((link) =>
                                    <li key={link.Href}><a href={link.Href}>{link.Text}</a></li>
                                )}
                </ul>
                        </>
                    }
                    </div>
                    
                    <div className="navbar__usp-container" dangerouslySetInnerHTML={{
                        __html: block,
                    }}></div>
                </ul>
            )}
        </Fragment>
    );
};

export default NavigationItem;
